function addContent(
  content_title,
  module_type,
  module_hex,
  headline_item,
  headline_destination
) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/content`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      content_title: content_title,
      module_type: module_type,
      module_hex: module_hex,
      headline_item: headline_item,
      headline_destination: headline_destination,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default addContent;
